import React from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import images from "../../../utilities/images/images";
import { url_291 } from "../../../custom_utilities/api_services";
import Sidebar from "../../Sidebar/Sidebar";
import DayStreak from "./DayStreak/DayStreak";
import StreakMilestone from "./StreakMilestone/StreakMilestone";
import ShareMenu from "./ShareMenu/ShareMenu";
import "./EngageHomepage.css";
import "./MilestonePage.css";

function isMilestoneAchieved(item) {
  const statusText = (item?.status || "").toLowerCase();
  return statusText === "achieved" || item?.is_achieved === true;
}

/** Number of achieved milestone tiers (batches): 1 achieved row → 1, 2 achieved rows → 2. */
function earnedBadgesTotal(milestones) {
  if (!Array.isArray(milestones)) return 0;
  return milestones.reduce((n, item) => n + (isMilestoneAchieved(item) ? 1 : 0), 0);
}

function MilestonePage() {
  const history = useHistory();
  const [pageData, setPageData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;
    const fetchMilestoneCard = async () => {
      try {
        const response = await axios.get(url_291);

        if (!cancelled && response?.data?.status === 200) {
          setPageData(response.data.data);
        }
      } catch (error) {
        console.log("API Error:", error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchMilestoneCard();
    return () => {
      cancelled = true;
    };
  }, []);

  const earnedTotal = pageData ? earnedBadgesTotal(pageData?.milestone_badges) : 0;
  const badgeNoun = earnedTotal === 1 ? "badge" : "badges";

  return (
    <main className="engage-homepage-shell">
      <Sidebar />
      <div className="engage-homepage">
        {loading ? (
          <div
            className="milestone-page milestone-page--loading"
            role="status"
            aria-live="polite"
            aria-busy="true"
            aria-label="Loading milestones"
          >
            <ClipLoader color="#C61C26" size={48} />
          </div>
        ) : pageData ? (
        <div className="milestone-page">
          <header className="milestone-page__header">
            <button
              type="button"
              className="milestone-page__back-btn"
              aria-label="Go back"
              onClick={() => history.push("/my-space")}
            >
              <img src={images.new_backarrow} alt="" />
            </button>

            <h2 className="milestone-page__title">
              Streak Milestone Journey
            </h2>
          </header>

          <div className="milestone-page__content">
            <DayStreak
              badgeUrl={pageData?.streak_url}
              title={pageData?.card_title}
              subtitle={pageData?.footer_message}
              statusLabel={pageData?.status_label}
              isProgress={pageData?.is_progress}
            />

            <StreakMilestone
              milestones={pageData?.milestone_badges}
            />

            <div className="milestone-page__share-section">
              <ShareMenu
                shareLink={pageData?.share_link}
                shareTitle={
                  pageData?.card_title || "My Streak Milestone Journey"
                }
                buttonLabel="Share Milestone Journey"
                buttonIcon={images.milestone_share_icon}
              />

              <p className="streak-milestone__note">
                {earnedTotal === 1 ? (
                  <>
                    You&apos;ve earned{" "}
                    <span className="streak-milestone__note-highlight">1 badge</span> total.
                    Legends are built one day at a time.
                  </>
                ) : (
                  <>
                    {`You've earned ${earnedTotal} ${badgeNoun} total. `}
                    Legends are built one day at a time.
                  </>
                )}
              </p>
            </div>
          </div>
        </div>
        ) : null}
      </div>
    </main>
  );
}

export default MilestonePage;
